import { StyleSheet } from "@react-pdf/renderer"


export const footerInLastPageStyles=()=>{

    const footerInLastPage = StyleSheet.create({
        container: {
            alignSelf: 'center',
            width:'100%'
        },
        thirdSections: {
            height:80,
            alignSelf: 'center',
            borderWidth: 1,
            borderColor: 'black',
            flexDirection: 'row',
        },
    })

    const notes = StyleSheet.create({
        container: {
            width: '70%',
            borderRightWidth: 1,
            borderColor: 'black',
            padding: 5
        },
        text: {
            fontSize: 7,
        }
    })

    const totals = StyleSheet.create({
        container: {
            width: '30%',
            padding: 4,
            paddingTop: 15,
            gap: 1,
            flexDirection: 'column',
            justifyContent: 'space-between'
        },
        totalField: {
            width: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: 3
        },
        concept: {
            fontSize: 6,
        },
        text: {
            fontSize: 6,
        }
    })

    return {
        footerInLastPage,
        notes,
        totals
    }

}